import { getType, ObjectType } from "./Object";

export function isFunction(value: unknown): boolean {
  if (value == null) {
    return false;
  }

  return getType(value) === ObjectType.Function;
}

export function isNotFunction(value: unknown): boolean {
  return !isFunction(value);
}
